import PropTypes from "prop-types";
import { Divider } from "antd";

export const ModuleCard = ({
  item,
  onClick,
  labelKey = "FCTERCERASECCION",
  imageKey = "FCURLIMAGEN3",
  href = null,
  variant = "button", // "button" | "link"
}) => {
  const label = item[labelKey] === "Inventario" ? "Inventarios" : item[labelKey];

  const CardContent = () => (
    <div className="admin-card-content">
      <div className="admin-card-icon">
        <img src={item[imageKey]} alt={label} />
      </div>
      <Divider type="vertical" className="divider" />
      <div className="admin-card-text">{label}</div>
    </div>
  );

  if (variant === "link" && href) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="admin-card admin-card-link"
        onClick={onClick}
        aria-label={label}
      >
        <CardContent />
      </a>
    );
  }

  return (
    <button className="admin-card" onClick={onClick} aria-label={label}>
      <CardContent />
    </button>
  );
};

ModuleCard.propTypes = {
  item: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  labelKey: PropTypes.string,
  imageKey: PropTypes.string,
  href: PropTypes.string,
  variant: PropTypes.oneOf(["button", "link"]),
};
